import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { FormInput } from 'components';

const LoginForm = ({
    form,
    onChange,
    onSubmit,
    loading
}) => {
    const { fields, meta } = form;

    return (
        <section className="container container--sml spc--top--xlrg box--white box--med box__shadow--3 box--rounded">
            <div className="type--center">
                <div className="logo logo--lrg"></div>
            </div>

            <div className="separator--primary spc--bottom--sml spc--top--sml"></div>

            <form className="form" onSubmit={onSubmit}>
                <label className="spc--bottom--sml display--ib">Email</label>
                <FormInput type="email"
                    name="email"
                    value={fields.email.value}
                    error={fields.email.error}
                    onChange={onChange}
                    placeholder="Email" />
                <label className="spc--bottom--sml display--ib">Password</label>
                <FormInput type="password"
                    name="password"
                    value={fields.password.value}
                    error={fields.password.error}
                    onChange={onChange}
                    placeholder="password" />

                {
                    meta.error && (
                        <div className="spc--bottom--med">
                            <p className="type--tiny type--color--error">{meta.error}</p>
                        </div>
                    )
                }
                <p>
                    <button type="submit" disabled={!meta.isValid} className="btn btn--primary btn--med"> Sign In</button>
                    { loading && <span style={{ paddingLeft: 10 }} className="type--small spc--left--sm">Logging in...</span> }
                </p>
            </form>
        </section>
    )
}

LoginForm.propTypes = {
    onChange: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    form: PropTypes.shape({
        fields: PropTypes.objectOf(PropTypes.shape({
            value: PropTypes.string.isRequired,
            error: PropTypes.any,
        })).isRequired,
        meta: PropTypes.shape({
            isValid: PropTypes.bool.isRequired,
            error: PropTypes.any
        }).isRequired
    }).isRequired
};

const observerLoginForm = observer(LoginForm);
export { observerLoginForm as LoginForm }


// WEBPACK FOOTER //
// ./src/modules/login/components/LoginForm.js